/* Copyright (c) 2023 Xperi. All Rights Reserved. */

/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum InteractiveComponents {
    EAST = 'EAST',
    NORTH = 'NORTH',
    OK = 'OK',
    SOUTH = 'SOUTH',
    WEST = 'WEST',
}
